// extracted by mini-css-extract-plugin
module.exports = {"button":"_3tfm8","invertedWithPlus":"_3ONWu","inverted":"_2z8Tx","active":"_2e6J8","altPrimary":"lpgPF","primary":"_3uUpH","large":"Pq41l"};